import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-prev-task-external-work',
  templateUrl: './prev-task-external-work.component.html',
  styleUrls: ['./prev-task-external-work.component.scss']
})
export class PrevTaskExternalWorkComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @ViewChild(MatSort) sort!: MatSort;

  externalWorkData = new MatTableDataSource<any>([]);

  externalWorkColumns: string[] = [
    'parameter',
    'target',
    'actual'
  ];

  constructor() { }

  ngOnInit() {
    this.getExternalWork();
  }

  getExternalWork(): void {
    this.externalWorkData.data = [
      { parameter: 'Waste Count', target: 12, actual: 0 },
      { parameter: 'Net Production', target: 15, actual: 0 },
      { parameter: 'Rewind Tension (N)', target: 20, actual: 0 },
      { parameter: 'Unwind Tension (N)', target: 10, actual: 0 }
    ];
    this.getPaginator();
  }

  actualChange(event: any, element: any): void {
    const newValue = Number(event.target.value);
    const index = this.externalWorkData.data.findIndex(item => item === element);

    if (index > -1) {
      this.externalWorkData.data[index].actual = newValue;
      this.externalWorkData._updateChangeSubscription();
    }
  }


  getPaginator(): void {
    setTimeout(() => {
      this.externalWorkData.paginator = this.paginator;
      this.externalWorkData.sort = this.sort;
    }, 1000);
  }

}
